export default __webpack_public_path__ + "static/media/fertilizer.916d40cc.jpeg";